import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { makeStyles } from '@material-ui/core/styles';

import { makeRowColumn, getHeadObj } from 'lib/commonLib';
import {
  adexApplyList,
  adexApplyDelete,
  adexApplyModify,
  getAdexUserList,
} from 'lib/api/adex';

import FilterWrap from 'components/atoms/FilterWrap';
import NewInput from 'components/atoms/NewInput';
import TableContainer from 'components/molecules/MbTable';
import BasicModalHeader from 'components/molecules/Modal/Header';
import BasicModalSection from 'components/molecules/Modal/Section';
import BasicModalFooter from 'components/molecules/Modal/Footer';
import BasicModal from 'components/organisms/Modal/Basic';
import NewCommonFilter from 'components/organisms/NewCommonFilter';
import NewButton from 'components/molecules/NewButton';
import FilterCollection from 'components/organisms/FilterCollection';
import SnackbarWrap from 'components/organisms/Snackbar/SnackbarWrap';
const useStyles = makeStyles((theme) => ({
  textfiled: {
    width: 250,
    '& input': {
      padding: '8px 14px',
    },
  },
  textTitle: {
    color: 'c5c6d0',
    marginBottom: 10,
    textAlign: 'center',
  },
}));

const Apply = () => {
  const initParams = {
    state: 'all',
    externalId: 'all',
  };
  const { t } = useTranslation();
  const classes = useStyles();
  const [params, setParams] = useState(initParams);
  const [initialization, setInitialization] = useState(false);
  const initModalControl = {
    open: false,
    headerOpen: false,
    headerTitle: '',
    closeBtn: false,
    cancelBtnOpen: false,
    confirmBtnOpen: false,
    cancelBtnTitle: '',
    confirmBtnTitle: '',
    siteName: '',
    message: '',
    reGetData: false,
    params: {
      memo: '',
    },
  };
  const initSnackbar = {
    state: false,
    variant: 'success',
    message: '',
  };
  const [modalControl, setModalControl] = useState(initModalControl);
  const [userFilterList, setUserFilterList] = useState([]);
  const [reGetData, setReGetData] = useState(false);
  const [snackbar, setSnackbar] = useState(initSnackbar);
  const [filterList] = useState({
    state: [
      { CODE_ID: 'all', CODE_DESC: t('전체') },
      { CODE_ID: '01', CODE_DESC: t('신규') },
      { CODE_ID: '02', CODE_DESC: t('대기') },
      { CODE_ID: '03', CODE_DESC: t('반려') },
    ],
  });

  useEffect(() => {
    getAdexUserData(); // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (initialization === true) {
      setInitialization(false);
    }
  }, [initialization]);

  useEffect(() => {
    // 렌더링 후에 실행됨
    // params setting(필터링 혹은 초기 param setting) > 렌더링 > 초기화 값 초기화
    setInitialization(false);
  }, [params]);

  // header 및 body 컬럼 커스텀
  const customized = {
    STATE: {
      makeHead: (headsMap) => {
        return <>지면 현황</>;
      },
      makeBody: (rowObj, headsMap) => {
        return (
          <>
            <NewButton
              icon="faPowerOff"
              iconBtn
              style={rowObj.STATE === 'Y' ? { backgroundColor: '#79bd2f' } : {}}
              color={rowObj.STATE === 'Y' ? '#fff' : undefined}
            />
          </>
        );
      },
    },
    PLTFOM_TYPE: {
      makeHead: (headsMap) => {
        return <>유형구분</>;
      },
      makeBody: (rowObj, headsMap) => {
        const pltfomType = getHeadObj(headsMap, 'PLTFOM_TYPE');

        return (
          <>
            {makeRowColumn(
              rowObj['PLTFOM_TYPE'],
              pltfomType.type,
              pltfomType.format
            )}
          </>
        );
      },
    },
    MEMO: {
      makeBody: (rowObj, headsMap) => {
        let memo = rowObj.MEMO;
        if (rowObj.MEMO === null) {
          memo = '';
        }
        return (
          <>
            <NewInput
              className={classes.textfiled}
              type={'tableInput'}
              placeholder="메모 입력 후 'ENTER'를 눌러주세요."
              value={memo}
              onKeyPress={(e) => handleMemoKeyPress(e, rowObj)}
            />
          </>
        );
      },
    },
  };

  /**
   * 연동플렛폼 리스트 받아오는 함수
   */
  const getAdexUserData = () => {
    getAdexUserList()
      .then((response) => {
        let { data } = response.data;
        data.unshift({
          CORP_NAME: t('전체'),
          USER_ID: 'all',
        });
        setUserFilterList(data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  /**
   * 수정처리 함수
   * @param tempParams
   */
  const handleAdexApplyAction = (type, tempParams) => {
    if (type === 'waiting' || type === 'reject' || type === 'modify') {
      adexApplyModify(tempParams)
        .then((response) => {
          setSnackbar({
            ...initSnackbar,
            state: true,
            variant: 'success',
            message: response.data.message,
          });
          setReGetData(true);
        })
        .catch((error) => {
          alert(error);
        })
        .finally(() => {
          setReGetData(false);
        });

      //일괄수정
    } else if (type === 'edit') {
      console.log('tempParams', tempParams);
      const tempModalControl = {
        ...modalControl,
        open: true,
        message: t('선택한 항목의 메모를 일괄 수정합니다.'),
        confirmState: true,
        confirmBtnOpen: true,
        confirmBtnTitle: '수정',
        cancelBtnOpen: true,
        cancelBtnTitle: '취소',
        reGetData: true,
        state: 'memoEdit',
        params: {
          ...tempParams,
        },
      };
      setModalControl(tempModalControl);
    } else if (type === 'delete') {
      adexApplyDelete(tempParams)
        .then((response) => {
          const tempModalControl = {
            ...modalControl,
            open: true,
            cancelBtnOpen: true,
            cancelBtnTitle: '확인',
            message: response.data.message,
            reGetData: true,
            state: 'applyModify',
          };
          setModalControl(tempModalControl);
          setReGetData(true);
        })
        .catch((error) => {
          setSnackbar({
            ...initSnackbar,
            state: true,
            variant: 'error',
            message: error,
          });
        })
        .finally(() => {
          setReGetData(false);
        });
    }
  };

  /**
   * 개별수정 memo
   * @param e
   * @param rowData
   */
  const handleMemoKeyPress = (e, rowData) => {
    if (e.charCode === 13) {
      let tempParams;
      tempParams = {
        // externalIds: props.EXL_ID,
        externalId: rowData.EXTERNAL_ID,
        mediaScriptNos: rowData.MEDIA_SCRIPT_NO,
        state: rowData.STATE_CODE,
        memo: e.target.value,
      };
      handleAdexApplyAction('modify', tempParams);
    }
  };

  /**
   * 체크박스 Btn Callback 함수
   * @param type String (엑션타입)
   * @param rowData Array ( 체크 유니크값)
   */
  const handleCheckBtnController = (type, data) => {
    let tmpExternalId = [];
    let tmpMediaScriptNo = [];
    data.forEach(function (rowData) {
      tmpMediaScriptNo.push(rowData.MEDIA_SCRIPT_NO);
      tmpExternalId.push(rowData.EXTERNAL_ID);
    });

    let params = {};
    if (type === 'waiting') {
      params = {
        state: '02',
        mediaScriptNos: tmpMediaScriptNo.join(),
        externalId: tmpExternalId.join(),
      };
      handleAdexApplyAction(type, params);
    } else if (type === 'reject') {
      params = {
        state: '03',
        mediaScriptNos: tmpMediaScriptNo.join(),
        externalId: tmpExternalId.join(),
      };
      handleAdexApplyAction(type, params);
    } else if (type === 'delete') {
      params = {
        mediaScriptNos: tmpMediaScriptNo.join(),
        externalIds: tmpExternalId.join(),
      };
      handleAdexApplyAction(type, params);
    } else if (type === 'edit') {
      params = {
        mediaScriptNos: tmpMediaScriptNo.join(),
        externalId: tmpExternalId.join(),
      };
      handleAdexApplyAction(type, params);
    }
  };

  const handleModalClose = () => {
    setModalControl(initModalControl);
  };

  const childColumnSet = {
    STATS_DTTM: () => {
      return null;
    },
  };

  /**
   * 스낵바 닫는 함수
   * 연속 클릭이 들어왔을 때는 기존 스낵바를 유지
   * @param event
   * @param reason
   */
  const handleSnackBarClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setSnackbar(initSnackbar);
  };

  /**
   * 테이블 클릭 후 세부정보 받아올때 보낼 param setting 해주는 함수
   * @param {json} data 테이블 로우 데이터
   */
  const makeSubParam = (data) => {
    return {
      statsDttm: data.STATS_DTTM,
    };
  };

  /**
   * 필터 초기화
   */
  const handleOnReset = () => {
    setInitialization(true);
    setParams({});
  };

  /**
   * 모달 데이터 변경했을 때 실행되는 함수
   * @param newParams
   */
  const modalGetParam = (newParams) => {
    setModalControl({
      ...modalControl,
      params: {
        ...modalControl.params,
        ...newParams,
      },
    });
  };

  /**
   * modal 확인 버튼 클릭시
   */
  const handleSubmit = () => {
    console.log('modalControl.params', modalControl.params);
    adexApplyModify(modalControl.params)
      .then((response) => {
        setSnackbar({
          ...initSnackbar,
          state: true,
          variant: 'success',
          message: response.data.message,
        });
        setReGetData(true);
        handleModalClose();
      })
      .catch((error) => {
        handleModalClose();
        setSnackbar({
          ...initSnackbar,
          state: true,
          variant: 'error',
          message: error,
        });
      })
      .finally(() => {
        setReGetData(false);
      });
  };

  const getParam = (newParams) => {
    setParams({
      ...params,
      ...newParams,
    });
  };

  return (
    <>
      <FilterWrap handleOnReset={handleOnReset}>
        <NewCommonFilter
          initialization={initialization}
          getParam={getParam}
          params={params}
          useDate={false}
          useExternalFilter={false}
          //useMediaTpCode={true}
          useSizeType={true}
          useDisplayFilter={true}
        />
        <FilterCollection
          label={t('연동플렛폼')}
          name="externalId"
          type="select"
          value={params.externalId}
          usePopover={true}
          labelKey="CORP_NAME"
          valueKey="USER_ID"
          list={userFilterList}
          params={params}
          callBack={getParam}
          useSubmit
          submitTitle={t('확인')}
        />
        <FilterCollection
          label={t('상태')}
          value={params.state}
          name="state"
          type="radio"
          params={params}
          list={filterList.state}
          labelKey="CODE_DESC"
          valueKey="CODE_ID"
          callBack={getParam}
        />
      </FilterWrap>
      <TableContainer
        dataReqPromise={adexApplyList}
        params={{ ...params }}
        getParam={getParam}
        dense
        customized={customized}
        hasExcel
        makeSubParam={makeSubParam}
        childColumnSet={childColumnSet}
        reGetData={reGetData}
        hasCheckbox={true}
        hasActController={{
          waiting: true,
          reject: true,
          delete: true,
          edit: true,
        }}
        headCallBack={handleCheckBtnController}
      />

      <BasicModal open={modalControl.open}>
        <BasicModalHeader
          headerOpen={modalControl.headerOpen}
          headerTitle={modalControl.headerTitle}
          closeBtn={modalControl.closeBtn}
          closeOnClick={handleModalClose}
        />
        <BasicModalSection>
          {modalControl.state === 'applyModify' && <>{modalControl.message}</>}
          {modalControl.state === 'memoEdit' && (
            <>
              <>
                {
                  <NewInput
                    className={classes.textfiled}
                    type={'tableInput'}
                    name="memo"
                    callBack={modalGetParam}
                    placeholder="일괄 변경할 메모를 입력하세요."
                    value={modalControl.params.memo}
                  />
                }
              </>
            </>
          )}
        </BasicModalSection>
        <BasicModalFooter
          confirmOnClick={handleSubmit}
          cancelOnClick={handleModalClose}
          cancelBtnOpen={modalControl.cancelBtnOpen}
          confirmBtnOpen={modalControl.confirmBtnOpen}
          cancelBtnTitle={modalControl.cancelBtnTitle}
          confirmBtnTitle={modalControl.confirmBtnTitle}
        />
      </BasicModal>

      <SnackbarWrap
        open={snackbar.state}
        onClose={handleSnackBarClose}
        variant={snackbar.variant}
        message={snackbar.message}
      />
    </>
  );
};

export default Apply;
